import { c as _c } from "react/compiler-runtime";
import linkArrowBlack from '@images/renders/visual_images/link-arrow-black.svg';
import linkArrowWhite from '@images/renders/visual_images/link-arrow-white.svg';
import ROUTES from '@lib/constants/routes';
import NextImage from 'next/image';
import Link from 'next/link';
import style from './ListLink.module.scss';
function ListLink(t0) {
  const $ = _c(3);
  const {
    color: t1
  } = t0;
  const color = t1 === undefined ? "black" : t1;
  const currentIcon = color === "black" ? linkArrowBlack : linkArrowWhite;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span>Выбор по параметрам</span>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== currentIcon) {
    t3 = <Link href={ROUTES.flats.list} className={style.listLink}>{t2}<NextImage src={currentIcon} alt="link-arrow" /></Link>;
    $[1] = currentIcon;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}
export default ListLink;